import { axios } from '@/utils/request'

const api = {
	getBillList:'/bill/getBillList',
  editBill:'/bill/editBill',
  queryInvoiceApplyInfo:'/bill/queryInvoiceApplyInfo',
  updateInvoiceStatusAndCourier:'/bill/updateInvoiceStatusAndCourier'
}

export default api

export function getBillList (parameter) {
  return axios({
    url: api.getBillList,
    method: 'post',
		headers: {
		  'Content-Type': 'application/json;charset=UTF-8'
		},
    data: JSON.stringify(parameter)
  })
}
export function editBill (parameter) {
  return axios({
    url: api.editBill,
    method: 'post',
		headers: {
		  'Content-Type': 'application/json;charset=UTF-8'
		},
    data: JSON.stringify(parameter)
  })
}

export function queryInvoiceApplyInfo (parameter) {
  return axios({
    url: api.queryInvoiceApplyInfo,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: JSON.stringify(parameter)
  })
}

export function updateInvoiceStatusAndCourier(parameter) {
  return axios({
    url: api.updateInvoiceStatusAndCourier,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: JSON.stringify(parameter)
  })
}


